import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TimeZoneOptions from "../../utils/timezones.json"; // Adjust the path as per your project structure

import {
  GENERAL_SETTING_GET_URL,
  GENERAL_SETTING_POST_URL,
} from "../../utils/Constant";
import { useSelector } from "react-redux";

const GeneralSettings = () => {
  const [settingDetails, setSettingDetails] = useState("");
  const [siteTitle, setSiteTitle] = useState("");
  const [tagLine, setTagLine] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [customerRegistrationFee, setCustomerRegistrationFee] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [port, setPort] = useState("");
  const [service, setService] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [postcode, setPostcode] = useState("");
  const [paypalBusinessId, setPaypalBusinessId] = useState("");
  const [isPremiumEnabled, setIsPremiumEnabled] = useState("");
  const [premiumType, setPremiumType] = useState("");
  const [premiumAmount, setPremiumAmount] = useState("");
  const [minPremiumAmount, setMinPremiumAmount] = useState("");
  const [maxPremiumAmount, setMaxPremiumAmount] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [keywords, setKeywords] = useState("");

  const [paymentMode, setPaymentMode] = useState("");
  const [liveClientId, setLiveClientId] = useState("");
  const [liveSecretKey, setLiveSecretKey] = useState("");
  const [sandboxClientId, setSandboxClientId] = useState("");
  const [sandboxSecretKey, setSandboxSecretKey] = useState("");

  const authToken = useSelector((state) => state.token);

  const navigate = useNavigate();

  useEffect(() => {
    if (authToken) {
      const fetchDetails = async () => {
        try {
          showToast(true, "Data Loading. Please wait..", "info");
          const response = await fetch(GENERAL_SETTING_GET_URL, {
            headers: {
              Authorization: `Bearer ${authToken.token}`,
            },
          });

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          const data = await response.json();

          //console.log("data>>>>>>>>", data);
          setSettingDetails(data.data);

          setSiteTitle(data.data.siteTitle || "");
          setTagLine(data.data.tagline || "");
          setAdminEmail(data.data.adminEmail || "");
          setCustomerRegistrationFee(data.data.customerRegistrationFee || "");

          setUsername(data.data.smtp.username || "");
          setPassword(data.data.smtp.password || "");
          setPort(data.data.smtp.port || "");
          setService(data.data.smtp.service || "");
          setAddressLine1(data.data.storeAddress.addressLine1 || "");
          setAddressLine2(data.data.storeAddress.addressLine2 || "");
          setCity(data.data.storeAddress.city || "");
          setCountry(data.data.storeAddress.country || "");
          setState(data.data.storeAddress.state || "");
          setPostcode(data.data.storeAddress.postcode || "");
          setPaypalBusinessId(data.data.paypalBusinessId || "");
          setIsPremiumEnabled(data.data.isPremiumEnabled || "");
          setPremiumType(data.data.premiumType || "");
          setPremiumAmount(data.data.premiumAmount || "");
          setMinPremiumAmount(data.data.minPremiumAmount || "");
          setMaxPremiumAmount(data.data.maxPremiumAmount || "");
          setMetaTitle(data.data.seo.metaTitle || "");
          setMetaDescription(data.data.seo.metaDescription || "");
          setKeywords(data.data.seo.keywords.join(",") || "");

          setPaymentMode(data.data.paypal.mode || "");
          setLiveClientId(data.data.paypal.client_id_live || "");
          setLiveSecretKey(data.data.paypal.client_secret_live || "");
          setSandboxClientId(data.data.paypal.client_id_sandbox || "");
          setSandboxSecretKey(data.data.paypal.client_secret_sandbox || "");
        } catch (error) {
          //console.error("Error fetching product:", error);
        }
      };
      fetchDetails();
    } else {
      navigate("/login");
    }
  }, []);
  //console.log("settingDetails", settingDetails);

  const showToast = (loading, message, type, errors) => {
    let errorMessage = "";

    if (errors && errors.length > 0) {
      errorMessage = (
        <ul>
          {errors.map((error, index) => (
            <li key={index}>{error.msg}</li>
          ))}
        </ul>
      );
    }
    toast[type](
      <div>
        {loading} {message} {errorMessage}
      </div>,
      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000, // milliseconds
      }
    );
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const wordsArray = keywords.split(",");
    //console.log(wordsArray);
    let formData = {
      siteTitle: siteTitle,
      tagline: tagLine,
      adminEmail: adminEmail,
      customerRegistrationFee: parseInt(customerRegistrationFee),
      smtp: {
        username: username,
        password: password,
        port: port,
        service: service,
      },
      storeAddress: {
        addressLine1: addressLine1,
        addressLine2: addressLine2,
        city: city,
        state: state,
        country: country,
        postcode: postcode,
      },
      paypalBusinessId: paypalBusinessId,
      isPremiumEnabled: isPremiumEnabled,
      premiumType: premiumType,
      premiumAmount: premiumAmount,
      minPremiumAmount: minPremiumAmount,
      maxPremiumAmount: maxPremiumAmount,
      seo: {
        metaTitle: metaTitle,
        metaDescription: metaDescription,
        keywords: wordsArray, // array
      },
      paypal: {
        mode: paymentMode,
        client_id_live: liveClientId,
        client_secret_live: liveSecretKey,
        client_id_sandbox: sandboxClientId,
        client_secret_sandbox: sandboxSecretKey,
      },
    };
    //console.log("formData", formData);
    try {
      showToast(true, "In Progress. Please wait..", "info");
      const response = await fetch(GENERAL_SETTING_POST_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken.token}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (response.ok) {
        showToast(true, "Setting updated successfully!", "success");
      } else {
        showToast(true, "An error occurred.", "error", data.errors);
      }
    } catch (error) {
      showToast(true, "Test :  " + error.message, "error");
      console.error(error.message, error);
    }
  };

  return (
    <DashboardLayout>
      <form onSubmit={handleFormSubmit}>
        <div class="row">
          <div class="col-md-7">
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">
                  <b>Basic Details</b>
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Collapse"
                  >
                    <i className="fas fa-minus" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="siteTitle">Site Title</label>
                  <input
                    type="text"
                    className="form-control"
                    id="siteTitle"
                    name="siteTitle"
                    value={siteTitle}
                    onChange={(e) => setSiteTitle(e.target.value)}
                    placeholder="Site Title"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="productDescription">Tag Line</label>
                  <input
                    type="text"
                    className="textarea form-control"
                    placeholder="Tag Line"
                    id="productDescription"
                    name="productDescription"
                    value={tagLine}
                    onChange={(e) => setTagLine(e.target.value)}
                    rows={5}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="shortDescription">Admin Email</label>
                  <input
                    type="email"
                    className="textarea form-control"
                    placeholder="Admin Email"
                    id="shortDescription"
                    name="shortDescription"
                    value={adminEmail}
                    onChange={(e) => setAdminEmail(e.target.value)}
                    rows={3}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="customerRegistrationFee">
                    Customer Registration Fee ($)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Customer Registration Fee"
                    id="customerRegistrationFee"
                    name="customerRegistrationFee"
                    value={customerRegistrationFee}
                    onChange={(e) => setCustomerRegistrationFee(e.target.value)}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="customerRegistrationFee">
                    Default Timezone
                  </label>
                  <select className="form-control custom-select">
                    <option value="">Select Time Zone</option>
                    {TimeZoneOptions.map((option, index) =>
                      option.utc.map((utc, idx) => (
                        <option key={idx + 1} value={utc}>
                          {utc}-{option.text}
                        </option>
                      ))
                    )}
                  </select>
                </div>
              </div>
              {/* /.card-body */}
            </div>
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">
                  <b>Store Address</b>
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Collapse"
                  >
                    <i className="fas fa-minus" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="addressLine1">Address Line 1</label>
                  <input
                    type="text"
                    className="form-control"
                    id="addressLine1"
                    name="addressLine1"
                    value={addressLine1}
                    onChange={(e) => setAddressLine1(e.target.value)}
                    placeholder="Address Line 1"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="addressLine2">Address Line 1</label>
                  <input
                    type="text"
                    className="textarea form-control"
                    placeholder="Address Line 1"
                    id="addressLine2"
                    name="addressLine2"
                    value={addressLine2}
                    onChange={(e) => setAddressLine2(e.target.value)}
                    rows={5}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="city">City</label>
                  <input
                    type="text"
                    className="textarea form-control"
                    placeholder="City"
                    id="city"
                    name="city"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    rows={3}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="country">Country</label>
                  <input
                    type="text"
                    className="textarea form-control"
                    placeholder="Country State"
                    id="country"
                    name="country"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    rows={3}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="state">State</label>
                  <input
                    type="text"
                    className="textarea form-control"
                    placeholder="Country State"
                    id="state"
                    name="state"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    rows={3}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="postcode">Postcode</label>
                  <input
                    type="text"
                    className="textarea form-control"
                    placeholder="Postcode"
                    id="postcode"
                    name="postcode"
                    value={postcode}
                    onChange={(e) => setPostcode(e.target.value)}
                    rows={3}
                  />
                </div>
              </div>
              {/* /.card-body */}
            </div>

            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">
                  <b>SEO Details</b>
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Collapse"
                  >
                    <i className="fas fa-minus" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="metaTitle">Meta Title</label>
                  <input
                    type="text"
                    className="form-control"
                    id="metaTitle"
                    name="metaTitle"
                    value={metaTitle}
                    onChange={(e) => setMetaTitle(e.target.value)}
                    placeholder="Meta Title"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="metaDescription">Meta Description</label>
                  <textarea
                    className="textarea form-control"
                    placeholder="Meta Description"
                    id="metaDescription"
                    name="metaDescription"
                    value={metaDescription}
                    onChange={(e) => setMetaDescription(e.target.value)}
                    rows={5}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="keywords">Keywords</label>
                  <textarea
                    className="textarea form-control"
                    placeholder="Keywords"
                    id="keywords"
                    name="keywords"
                    value={keywords}
                    onChange={(e) => setKeywords(e.target.value)}
                    rows={3}
                  />
                </div>
              </div>
              {/* /.card-body */}
            </div>
          </div>
          <div class="col-md-5">
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">
                  <b>Premium Details</b>
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Collapse"
                  >
                    <i className="fas fa-minus" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="isPremiumEnabled">Premium Enabled</label>
                      <select
                        className="form-control custom-select"
                        name="isPremiumEnabled"
                        value={isPremiumEnabled}
                        onChange={(e) => setIsPremiumEnabled(e.target.value)}
                      >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="premiumType">Premium Type</label>
                      <select
                        className="form-control custom-select"
                        name="premiumType"
                        value={premiumType}
                        onChange={(e) => setPremiumType(e.target.value)}
                        // disabled={isPremiumEnabled == "false"}
                      >
                        <option value="flat">Flat ($)</option>
                        <option value="percentage">Percentage (%)</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group">
                      <label htmlFor="premiumAmount">Premium Amount</label>
                      <input
                        type="number"
                        className="form-control"
                        id="premiumAmount"
                        placeholder="Premium Fee Amount (in % or $)"
                        name="premiumAmount"
                        // disabled={isPremiumEnabled == "false"}
                        value={premiumAmount}
                        required
                        onChange={(e) => setPremiumAmount(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group">
                      <label htmlFor="minPremiumAmount">
                        Min Premium Amount ($)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="minPremiumAmount"
                        placeholder="Min Premium Amount ($)"
                        name="minPremiumAmount"
                        disabled={
                          isPremiumEnabled == "false" || premiumType == "flat"
                        }
                        value={minPremiumAmount}
                        required
                        onChange={(e) => setMinPremiumAmount(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group">
                      <label htmlFor="maxPremiumAmount">
                        Max Premium Amount ($)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="maxPremiumAmount"
                        placeholder="Max Premium Amount ($)"
                        name="maxPremiumAmount"
                        required
                        disabled={
                          isPremiumEnabled == "false" || premiumType == "flat"
                        }
                        value={maxPremiumAmount}
                        onChange={(e) => setMaxPremiumAmount(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* /.card-body */}
            </div>
            <div className="card card-default  collapsed-card">
              <div className="card-header">
                <h3 className="card-title">
                  <b>SMTP Details</b>
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Collapse"
                  >
                    <i className="fas fa-plus" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="username">Username</label>
                  <input
                    type="text"
                    className="form-control"
                    id="username"
                    name="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Username"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    className="textarea form-control"
                    placeholder="Password"
                    id="password"
                    name="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    rows={5}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="port">Port</label>
                  <input
                    input="text"
                    className="textarea form-control"
                    placeholder="Port"
                    id="port"
                    name="port"
                    value={port}
                    onChange={(e) => setPort(e.target.value)}
                    rows={3}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="service">Service</label>
                  <textarea
                    className="textarea form-control"
                    placeholder="Service"
                    id="service"
                    name="service"
                    value={service}
                    onChange={(e) => setService(e.target.value)}
                    rows={3}
                  />
                </div>
              </div>
              {/* /.card-body */}
            </div>
            <div className="card card-default  collapsed-card">
              <div className="card-header">
                <h3 className="card-title">
                  <b>Paypal Address</b>
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Collapse"
                  >
                    <i className="fas fa-plus" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                {/* <div className="form-group">
                  <label htmlFor="paypalBusinessId">paypal Business Id</label>
                  <input
                    type="text"
                    className="form-control"
                    id="paypalBusinessId"
                    name="paypalBusinessId"
                    value={paypalBusinessId}
                    onChange={(e) => setPaypalBusinessId(e.target.value)}
                    placeholder="paypal Business Id"
                  />
                </div> */}
                <div className="form-group">
                  <label htmlFor="paymentMode">Payment Mode</label>
                  <select
                    className="form-control custom-select"
                    name="paymentMode"
                    value={paymentMode}
                    onChange={(e) => setPaymentMode(e.target.value)}
                    // disabled={isPremiumEnabled == "false"}
                  >
                    <option value="sandbox">Sandbox</option>
                    <option value="live">Live</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="liveClientId">Live Client Id</label>
                  <input
                    type="text"
                    className="form-control"
                    id="liveClientId"
                    name="liveClientId"
                    value={liveClientId}
                    onChange={(e) => setLiveClientId(e.target.value)}
                    placeholder="Live Client Id"
                    disabled={paymentMode !== "live"}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="liveSecretKey">Live Secret Key</label>
                  <input
                    type="text"
                    className="form-control"
                    id="liveSecretKey"
                    name="liveSecretKey"
                    value={liveSecretKey}
                    onChange={(e) => setLiveSecretKey(e.target.value)}
                    placeholder="Live Secret Key"
                    disabled={paymentMode !== "live"}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="sandboxClientId">Sandbox Client Id</label>
                  <input
                    type="text"
                    className="form-control"
                    id="sandboxClientId"
                    name="sandboxClientId"
                    value={sandboxClientId}
                    onChange={(e) => setSandboxClientId(e.target.value)}
                    placeholder="Sandbox Client Id"
                    disabled={paymentMode !== "sandbox"}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="sandboxSecretKey">Sandbox Secret Key</label>
                  <input
                    type="text"
                    className="form-control"
                    id="sandboxSecretKey"
                    name="sandboxSecretKey"
                    value={sandboxSecretKey}
                    onChange={(e) => setSandboxSecretKey(e.target.value)}
                    placeholder="Sandbox Secret Key"
                    disabled={paymentMode !== "sandbox"}
                  />
                </div>
              </div>
              {/* /.card-body */}
            </div>
            <div className="card card-default">
              <div className="card-body">
                <div className="form-group">
                  <input
                    type="submit"
                    // value={productId ? "Update Auction" : "Create Auction"}
                    defaultValue="Publish Setting"
                    className="btn btn-success float-right"
                    value="Update Setting"
                  />
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
      </form>
    </DashboardLayout>
  );
};

export default GeneralSettings;
